// extracted by mini-css-extract-plugin
module.exports =  {"legendPositionRoot":"LegendPosition-module__legendPositionRoot--hFvfL"};